import { calculatePaymentDatesFromDocuments } from './calculatePaymentDatesFromDocuments';
import { calculatePaymentDates } from './calculatePaymentDates';

export const calculateAmortizationSimple = ({
  creditDetails,
  setAmortizationSchedule,
  workingDayActive,
  documents,
}: {
  creditDetails: any;
  setAmortizationSchedule: any;
  workingDayActive: 'active' | 'inactive';
  documents?: any;
}) => {
  const totalMonths = Number(creditDetails.months);
  const operationCost = creditDetails.operationCost || 0;
  const operationCostIVA = Math.round(operationCost * 0.19) || 0;
  const otherExpenses = creditDetails.otherExpenses || 0;
  const initialBalance =
    creditDetails.amount + operationCost + operationCostIVA + otherExpenses;

  console.log('initialBalance', initialBalance);
  console.log(
    'initialBalance',
    initialBalance,
    operationCost,
    operationCostIVA,
  );

  // --- 1. Calcular las fechas de pago ---
  const operationDate = new Date(creditDetails.operationDate);
  const firstPaymentDate = new Date(
    creditDetails.firstPaymentDate || documents?.[0]?.paymentDate,
  );

  if (firstPaymentDate <= operationDate) {
    console.error(
      'La fecha de primer pago debe ser al menos un mes después de la fecha de operación.',
    );
    return;
  }

  let paymentDates: any[] = [];
  if (documents) {
    paymentDates = calculatePaymentDatesFromDocuments(documents, creditDetails);
  } else {
    paymentDates = calculatePaymentDates(
      creditDetails,
      firstPaymentDate,
      workingDayActive,
      operationDate,
      totalMonths,
    );
  }

  console.log('paymentDates', paymentDates);

  // --- 2. Calcular el interés total (Simple) ---
  const totalInterest =
    initialBalance *
    (creditDetails.rate / 30 / 100) *
    getTotalDays(paymentDates);
  const totalToPay = initialBalance + totalInterest;
  const cuotaFija = totalToPay / totalMonths;

  // --- 3. Generar el cronograma ---
  const schedule: any[] = [];
  let balance = initialBalance;
  let totalAmortization = 0;
  const interestPerInstallment = totalInterest / totalMonths;

  paymentDates.forEach((payment: any, index: number) => {
    const principal = cuotaFija - interestPerInstallment;
    balance -= principal;
    totalAmortization += principal;

    schedule.push({
      month: index + 1,
      paymentDate: payment.date,
      amount: cuotaFija,
      interest: interestPerInstallment,
      principal: principal,
      balance: balance < 0 ? 0 : balance,
      operationCost: operationCost,
      otherExpenses: otherExpenses,
      totalAmortization: totalAmortization,
    });
  });

  setAmortizationSchedule(schedule);
};

// Función auxiliar para sumar días totales de los periodos
const getTotalDays = (paymentDates: any[]) => {
  return paymentDates.reduce((acc, p) => acc + p.diffDays, 0);
};

// Tus funciones existentes para calcular fechas se mantienen igual
